import React from "react";

interface ArrowIconProps {
    width: number;
    height: number;
}

function ArrowIcon({width, height}: ArrowIconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 10 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.75" d="M1 1L9 12L1 23" stroke="#63666A"/>
        </svg>
    );
}

export default ArrowIcon;
